var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAwesomeLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.862,
    height: 12.862,
    viewBox: "0 0 12.862 12.862",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-link",
    "data-name": "Icon awesome-link",
    d: "M8.2,4.657a3.816,3.816,0,0,1,.009,5.391l-.009.009L6.517,11.746a3.818,3.818,0,0,1-5.4-5.4l.932-.932a.4.4,0,0,1,.686.266A4.629,4.629,0,0,0,2.978,7a.4.4,0,0,1-.1.417l-.329.329A1.809,1.809,0,1,0,5.1,10.324L6.784,8.637a1.808,1.808,0,0,0,0-2.558,1.882,1.882,0,0,0-.26-.215.4.4,0,0,1-.175-.317A1,1,0,0,1,6.643,4.8l.529-.529a.4.4,0,0,1,.517-.043,3.83,3.83,0,0,1,.516.432Zm3.54-3.541a3.823,3.823,0,0,0-5.4,0L4.657,2.8l-.009.009a3.819,3.819,0,0,0,.525,5.823.4.4,0,0,0,.517-.043l.529-.529a1,1,0,0,0,.294-.749A.4.4,0,0,0,6.338,7a1.882,1.882,0,0,1-.26-.215,1.808,1.808,0,0,1,0-2.558L7.766,2.538a1.809,1.809,0,1,1,2.542,2.574l-.329.329a.4.4,0,0,0-.1.417,4.629,4.629,0,0,1,.243,1.324.4.4,0,0,0,.686.266l.932-.932a3.822,3.822,0,0,0,0-5.4Z",
    transform: "translate(0)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwesomeLink);
export default __webpack_public_path__ + "static/media/awesome-link.48cc40b1941fee605e2cdd6b757c0aa7.svg";
export { ForwardRef as ReactComponent };